import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

import loanOwnerNew from '../../../features/users/components/marketplace/icons/loan_owner_new.png'

export const LoanOfficer: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ..._props }, _ref) => {
  return <img src={loanOwnerNew} alt="Loan Officer" width={size} height={size} style={{ width: size, height: size }} />
})

LoanOfficer.displayName = 'LoanOfficer'
